import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';

@Component({
    selector: 'app-detail-prod-p',
    templateUrl: './detail-prod-p.component.html',
    styleUrls: ['./detail-prod-p.component.css']
})
export class DetailProdPComponent implements OnInit {
    public detail: any;
    public list: any;

    constructor(
        private appTranslateService: AppTranslateService,
        private catalogueService: CatalogueService,
        public dialogRef: MatDialogRef<DetailProdPComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.loadcataloguedetail();
    }


    close(feedback = null): void {

        this.dialogRef.close();
    }

    loadcataloguedetail() {
        this.catalogueService.loadDetailCatalogue(this.data.prodId)
            .subscribe(response => {

                this.detail = response['payload'];
                this.list = response['payload']['listSpecTech'];




            });

    }
}
